"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2631],{

/***/ 37277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








function AppSlider(param) {
    let { list , title , directionLTR , width , numbers , titleMargin , sliderPad , pointer  } = param;
    var settings = {
        infinite: true,
        speed: 1500,
        slidesToShow: numbers ? numbers : 5,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: false,
        arrows: false,
        easing: "linear",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        sx: {
            padding: sliderPad ? sliderPad : "0"
        },
        className: "container",
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                style: {
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px 0",
                    margin: titleMargin ? titleMargin : "auto"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: {
                            background: "white",
                            padding: "0 8px",
                            zIndex: 1,
                            fontWeight: "bold",
                            fontSize: {
                                xs: "24px",
                                md: "32px"
                            }
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        style: {
                            position: "absolute",
                            height: 1,
                            width: "100%",
                            background: "lightgray",
                            top: "calc(50% + 0.5px)",
                            zIndex: 0
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                style: {
                    padding: "8px 0",
                    transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...settings,
                    children: list.map((m, i)=>{
                        var ref;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: (m === null || m === void 0 ? void 0 : (ref = m.redirectLink) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                href: m.redirectLink,
                                rel: "preload",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    width: width ? width : 140,
                                    height: 140,
                                    src: m.icon,
                                    alt: m.name,
                                    style: {
                                        // width: width ? width : 140,
                                        maxWidth: width ? width : 140,
                                        margin: "auto",
                                        border: "none",
                                        outline: "none",
                                        transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)",
                                        objectFit: "contain",
                                        //   maxHeight: "70px !important",
                                        cursor: pointer ? "pointer" : "normal"
                                    },
                                    className: "app-slider-img",
                                    loading: "lazy"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                src: m.icon,
                                alt: m.name,
                                width: width ? width : 140,
                                height: 140,
                                style: {
                                    width: width ? width : 140,
                                    maxWidth: width ? width : 140,
                                    margin: "auto",
                                    border: "none",
                                    outline: "none",
                                    transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)",
                                    objectFit: "contain",
                                    //   maxHeight: "70px !important",
                                    cursor: pointer ? "pointer" : "normal"
                                },
                                className: "app-slider-img",
                                loading: "lazy"
                            })
                        }, i);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppSlider);


/***/ }),

/***/ 59584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86886);
/* harmony import */ var _AppSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37277);
/* harmony import */ var _data_StaticList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47027);





function Brand() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        container: true,
        sx: {
            position: "relative",
            minHeight: {
                xs: "30vh",
                md: "50vh"
            },
            justifyContent: "space-around",
            flexDirection: "column",
            padding: {
                xs: "48px 0",
                md: "60px 0"
            },
            maxWidth: "1440px",
            margin: "auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                list: _data_StaticList__WEBPACK_IMPORTED_MODULE_3__/* .BRAND_1_LIST */ .M0,
                directionLTR: true,
                width: 240,
                numbers: 4,
                title: "Our Financial Partners",
                titleMargin: "25px auto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                list: _data_StaticList__WEBPACK_IMPORTED_MODULE_3__/* .BRAND_2_LIST */ .xM,
                width: 240,
                numbers: 4
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Brand);


/***/ })

}]);